import { ReactElement } from 'react';
import { Card, CardContent, CardActions } from '@mui/material';
import { useAwsEffect, useRoutes } from '@localstack/services';
import { LambdaCreateFunctionCommandInput } from '@localstack/types';
import { ProgressButton, LambdaFunctionCreateForm, PageTitle } from '@localstack/ui';

import { LambdaProps } from './types';

export const LambdaFunctionCreate = ({ Layout, clientOverrides, routes }: LambdaProps): ReactElement => {
  const { goto } = useRoutes();

  const { createFunction, isLoading } = useAwsEffect('Lambda', ['createFunction'], {
    revalidate: ['listFunctions'],
    clientOverrides,
  });

  const handleCreate = async (data: LambdaCreateFunctionCommandInput) => {
    if (await createFunction(data)) {
      goto(routes.RESOURCES_LAMBDA_FUNCTION, { name: data.FunctionName });
    }
  };

  return (
    <Layout
      documentTitle="Lambda: Create Event Function"
      title={
        <PageTitle
          title="Create Event Function"
          breadcrumbs={[
            ['Lambda', () => goto(routes.RESOURCES_LAMBDA)],
            ['Event Functions', () => goto(routes.RESOURCES_LAMBDA_FUNCTIONS)],
            ['Create ', null],
          ]}
        />
      }
      actions={
        <ProgressButton
          type="submit"
          form="CreateLambdaFunction"
          variant="outlined"
          color="primary"
          loading={isLoading}
        >
          Submit
        </ProgressButton>
      }
    >
      <Card>
        <CardContent>
          <LambdaFunctionCreateForm
            onSubmit={handleCreate}
            formId="CreateLambdaFunction"
            loading={isLoading}
            clientOverrides={clientOverrides}
          />
        </CardContent>
        <CardActions>
          <ProgressButton
            type="submit"
            form="CreateLambdaFunction"
            variant="contained"
            color="primary"
            loading={isLoading}
          >
            Submit
          </ProgressButton>
        </CardActions>
      </Card>
    </Layout>
  );
};
